import { Component, Inject, Input, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CommonServices } from "src/app/common.services";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-admin-edit-trips",
  templateUrl: "./admin-edit-trips.component.html",
  styleUrls: ["./admin-edit-trips.component.css"],
})
export class AdminEditTripsComponent implements OnInit {
  editTripform!: FormGroup;
  tripArray: any;
  selectCatgValue: any;
  searchEmployeeName: any = -1;
  employeeName: any = [];
  perPage: any = 10;
  employeeStartPage: any = 1;
  vehiclelists: any;
  token: any;
  item: any;
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  searchtripID: any = -1;
  vehiclenoArray: any;
  work_order_msg: any;
  selectedDriverId: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  loading: boolean = false;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truckArray: any[] = [];
  searchQuery: any = -1;
  paginationTrips: boolean = true;
  tripsArray: any;
  tripType: any = "-1";
  last_page: any = 1;
  document_array: any = [];
  podImage: any = "";
  podImageName: any;
  uploadPod: boolean = true;
  podLoading: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminEditTripsComponent>,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private commonServices: CommonServices
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.employeeGet(this.searchEmployeeName);
    this.trips(this.searchtripID);

    this.editTripform = this.formBuilder.group({
      username: ["", Validators.required],
      work_order: [""],
      trip_id: [""],
      truck_ownerName: [""],
      truck_ownerNumber: [""],
      truck_number: [""],
      driver_number: [""],
      driver_name: [""],
      unloading_point: [""],
      user_id: [""],
      work_date: [""],
      workorder_id: [""],
      mobile: [""],
      driver_ref_id: [""],
      total_tons: [""],
      truckowner_id: [""],
      remaining_tons: [""],
      trip_booking_date: [""],
      truck_id: [""],
      driver_id: [""],
      driver_no: [""],
      loading_point: [""],
      price_per_ton: [""],
      sales_order_number: [""],
      lr_number: [""],
      lr_date: [""],
      tax_invoice_no: [""],
      ddc_no: [""],
      entry_by: [""],
      epod_received_on: [""],
      physical_pod_received_on: [""],
      eway_bill_no: [""],
    });
    if (this.data) {
      this.getVehicleList();
    }

    // Assuming trip_history is part of the data object
    const tripHistory = this.data.trip_history;
    const tripStatus = this.data.trip_status;

    // Check if `trip_status` is "completed"
    const isTripCompleted = tripStatus === "completed";

    // Check if `loading_done` with `is_verified: 1` exists in trip_history
    const isLoadingDoneVerified = tripHistory?.some(
      (event: any) => event.name === "loading_done" && event.is_verified === 1
    );

    const tripBookingData = this.data.trip_history;
    // Check if `loading_done` with `is_verified: 1` exists in trip_history
    const isVerified = tripBookingData?.some(
      (event: any) => event.name === "loading_done" && event.is_verified === 1
    );

    const driverData = this.data.trip_history;
    // Check if `loading_done` with `is_verified: 1` exists in trip_history
    const isDriverVerified = driverData?.some(
      (event: any) => event.name === "loading_done" && event.is_verified === 1
    );
    const driverNumber = this.data.trip_history;
    // Check if `loading_done` with `is_verified: 1` exists in trip_history
    const driverVerified = driverNumber?.some(
      (event: any) => event.name === "loading_done" && event.is_verified === 1
    );

    this.editTripform.patchValue(this.data);
    this.editTripform.patchValue({
      username: this.data.userInfo[0]?.username,
      trip_id: this.data.trip_id,
      mobile: this.data.userInfo[0]?.mobile,
      user_id: this.data.userInfo[0]?.user_id,
      trip_booking_date: this.data.pickup_date,
      truck_id: this.data.truckInfo?.truck_id,
      truck_ownerName: this.data.truckownerInfo[0]?.username,
      truck_ownerNumber: this.data.truckownerInfo[0]?.mobile,
      truck_number: this.data.truckInfo[0]?.truck_number,
      driver_id: this.data.driverInfo[0]?.username,
      driver_number: this.data.driverInfo[0]?.mobile,
      lr_number: this.data.workOrderOtherDetails?.lr_number,
      price_per_ton: this.data.workOrderOtherDetails?.price_per_ton,
      driver_ref_id: this.data.driver_ref_id,
      workorder_id: this.data.workorder_id,
      lr_date: this.data.workOrderOtherDetails?.lr_date,
      tax_invoice_no: this.data.workOrderOtherDetails?.tax_invoice_no,
      ddc_no: this.data.workOrderOtherDetails?.ddc_no,
      entry_by: this.data.workOrderOtherDetails?.entry_by,
      sales_order_number: this.data.workOrderOtherDetails?.sales_order_number,
      loading_point: this.data.workOrderOtherDetails?.loading_point,
      unloading_point: this.data.workOrderOtherDetails?.unloading_point,
      epod_received_on: this.data.workOrderOtherDetails?.epod_received_on,
      physical_pod_received_on: this.data.workOrderOtherDetails?.physical_pod_received_on,
      eway_bill_no: this.data.workOrderOtherDetails?.eway_bill_no,
    });
    // Disable the `truck_number` field if the condition is met
    if (isLoadingDoneVerified || isTripCompleted) {
      this.editTripform.get("truck_number")?.disable();
    }
    // Disable the `truck_number` field if the condition is met
    if (isVerified || isTripCompleted) {
      this.editTripform.get("trip_booking_date")?.disable();
    }

    // Disable the `truck_number` field if the condition is met
    if (isDriverVerified || isTripCompleted) {
      this.editTripform.get("driver_id")?.disable();
    }
    // Disable the `truck_number` field if the condition is met
    if (driverVerified || isTripCompleted) {
      this.editTripform.get("driver_number")?.disable();
    }

    if (this.data && this.data.pod_url) {
      this.podImage = this.data.pod_url;
      this.uploadPod = false;
      this.podImageName = 'pod_document';
    }
  }

  validateTaxInvoiceInput(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);
    const pattern = /^[a-zA-Z0-9/-]*$/;
    if (!pattern.test(charStr)) {
      event.preventDefault();
    }
  }

  validateNumericInput(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);
    const pattern = /^[0-9]*$/;
    if (!pattern.test(charStr)) {
      event.preventDefault();
    }
  }

  selectChangeHandler(item: any) { }

  public get editFormControl() {
    return this.editTripform.controls;
  }

  getVehicleList() {
    this.services
      .vehicleListEndTrip(this.token, this.data.truck_category, this.data.truckInfo[0]?._id)
      .subscribe(
        (response: any) => {
          this.truckArray = response.body;

          this.truckArray.filter((ele: any) => {
            if (ele._id == this.data.truckInfo[0]?._id) {
              this.editTripform.patchValue({
                truck_number: ele._id,
              });
            }
          });
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  public getVehiclesList(item: any) {
    this.selectCatgValue = item.value;
    this.services.GetVehicle(this.selectCatgValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.vehiclelists = response.body.data;
          this.selectedDriverId = this.vehiclelists.driverInfo[0]?._id;
          this.editTripform.patchValue({
            driver_number: this.vehiclelists?.driverInfo[0]?.mobile,
            driver_id: this.vehiclelists?.driverInfo[0]?.username,
            truck_ownerNumber: this.vehiclelists?.truckOwnerInfo[0]?.mobile,
            truck_ownerName: this.vehiclelists?.truckOwnerInfo[0]?.username,
          });
          const tested = this.truckArray.filter((item: any) => {
            return item.truck_number == this.vehiclelists.truck_number;
          });
          if (tested[0].truck_status === "trip_booked") {
            this.snackBar.open(
              "Truck Is Already in Trip Please Select Another Truck",
              "Fail",
              {
                duration: 5000,
              }
            );
            return;
          }
          if (this.vehiclelists.driverInfo.length == 0) {
            this.snackBar.open(
              "Truck Driver Not Available Please Select Another Truck",
              "Fail",
              { duration: 5000 }
            );
            return;
          }
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  employeeGet(item: any) {
    this.services
      .getUsersEmployees(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.employeeStartPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.employeeName = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  trips(type: any) {
    this.searchtripID = type;
    this.loading = true;
    this.services
      .GetAdminTrips(
        this.token,
        this.startPage,
        this.perPage,
        this.searchQuery,
        this.searchtripID,
        this.tripType
      )
      .subscribe(
        (response: any) => {
          this.loading = false;
          this.tripsArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;
        },
        (error) => {
          this.tripsArray = [];
          this.loading = false;
          if (error.status == 404) {
            this.paginationTrips = false;
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");

            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");

            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public formatFormDate(date: Date | undefined): string {
    if (!date) return ""; // Return empty string if date is undefined
    return formatDate(date, this.dateFormat, this.language);
  }

  UpdateTrips(event: any) {
    this.loading = true; // ✅ Disable button immediately

    let veh_No = this.editTripform.value.truck_number;

    // Check if the field is disabled and assign `this.data.pickup_date` if necessary
    if (this.editTripform.get("truck_number")?.disabled) {
      veh_No = this.data.truckInfo[0]?.truck_number;
    }

    if (!veh_No) {
      this.loading = true;
      this.snackBar.open("Please enter Vehicle no", "Fail", {
        duration: 5000,
      });
      this.loading = false;

      return;
    }

    let price_perTons = this.editTripform.value.price_per_ton;

    if (!price_perTons) {
      this.loading = true;
      this.snackBar.open("Please enter Price Per Tons", "Fail", {
        duration: 5000,
      });
      this.loading = false;

      return;
    }
    let sales_no = this.editTripform.value.sales_order_number;

    if (!sales_no) {
      this.loading = true;
      this.snackBar.open("Please enter Sales Order No", "Fail", {
        duration: 5000,
      });
      this.loading = false;

      return;
    }
    let lr_number = this.editTripform.value.lr_number;

    if (!lr_number) {
      this.loading = true;
      this.snackBar.open("Please enter LR Number", "Fail", {
        duration: 5000,
      });
      this.loading = false;

      return;
    }
    // let lr_date_no = this.editTripform.value.lr_date;

    // if (!lr_date_no) {
    //   this.loading = true;
    //   this.snackBar.open("Please enter LR Date", "Fail", {
    //     duration: 5000,
    //   });
    //   this.loading = false;

    //   return;
    // }
    let tax_no = this.editTripform.value.tax_invoice_no;

    if (!tax_no) {
      this.loading = true;
      this.snackBar.open("Please enter Tax Invoice No", "Fail", {
        duration: 5000,
      });
      this.loading = false;

      return;
    }
    let ddc_No = this.editTripform.value.ddc_no;

    if (!ddc_No) {
      this.loading = true;
      this.snackBar.open("Please enter DDC No", "Fail", {
        duration: 5000,
      });
      this.loading = false;

      return;
    }
    if (this.vehiclelists) {
      const sampleTest = this.truckArray.filter((item: any) => {
        return item.truck_number == this.vehiclelists?.truck_number;
      });

      if (sampleTest[0]?.truck_status === "trip_booked") {
        this.loading = true;
        this.snackBar.open(
          "Truck Is Already in Trip Please Select Another Truck",
          "Fail",
          {
            duration: 5000,
          }
        );
        this.loading = false;

        return;
      }
      if (this.vehiclelists?.driverInfo?.length == 0) {
        this.loading = true;
        this.snackBar.open(
          "Truck Driver Not Available Please Select Another Truck",
          "Fail",
          { duration: 5000 }
        );
        this.loading = false;

        return;
      }
    }

    const tripsObj = {
      trip_booking_date: this.editTripform.get("trip_booking_date")?.disabled
        ? this.data.pickup_date // If disabled, use `this.data.pickup_date`
        : this.editTripform.value.trip_booking_date, // Otherwise, use the form value
      truck_id: this.selectCatgValue || this.data.driverInfo[0]?.truck_id,
      driver_id: this.selectedDriverId || this.data.driverInfo[0]?._id,
      truckowner_id:
        this.vehiclelists?.truckOwnerInfo[0]?._id ||
        this.data.truckInfo[0]?.truckowner_id,
      workorder_id: this.editTripform.value.workorder_id,
      driver_ref_id: this.selectedDriverId || this.data.driverInfo[0]?._id,
      loading_point: Number(this.editTripform.value.loading_point) || 0,
      unloading_point: Number(this.editTripform.value.unloading_point) || 0,
      price_per_ton: Number(this.editTripform.value.price_per_ton),
      sales_order_number: this.editTripform.value.sales_order_number,
      lr_number: this.editTripform.value.lr_number,
      lr_date: this.formatFormDate(this.editTripform.value.lr_date),
      tax_invoice_no: this.editTripform.value.tax_invoice_no,
      ddc_no: this.editTripform.value.ddc_no,
      entry_by: this.editTripform.value.entry_by || "",
      epod_received_on: this.formatFormDate(this.editTripform.value.epod_received_on),
      physical_pod_received_on: this.formatFormDate(this.editTripform.value.physical_pod_received_on),
      eway_bill_no: this.editTripform.value.eway_bill_no,
      pod_url: this.podImage || "",
    };

    // if (tripsObj.loading_point === 0) {
    //   this.snackBar.open("Loading Point cannot be zero", "Fail", {
    //     duration: 5000,
    //   });
    //   return;
    // }
    if (tripsObj.price_per_ton === 0) {
      this.snackBar.open("Price per ton cannot be zero", "Fail", {
        duration: 5000,
      });
      this.loading = false;

      return;
    }

    this.services.tripEditTrip(tripsObj, this.token, this.data._id).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.matdialogref.close();
          this.loading = false;
          this.snackBar.open("Trip details updated successfully", "Success", {
            duration: 5000,
          });
        }
        // setTimeout(() => {
        //   this.loading = false; // ✅ Enable button after response
        //   (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
        // }, 500);
      },
      (error) => {
        this.loading = false;
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  close() {
    this.matdialogref.close();
  }

  onUploadPOD(event: any): void {
    this.podLoading = true;
    const file = event.target.files[0];
    this.services.uploadImage(file).subscribe((response: any) => {
      if (response.status === 201) {
        this.podLoading = false;
        var imgType = file.type.split("/");
        if (
          imgType[1] === "jpg" ||
          imgType[1] === "png" ||
          imgType[1] === "jpeg" ||
          imgType[1] === "pdf" ||
          imgType[0] === "image"
        ) {
          this.uploadPod = false;
          this.podImageName = file.name.slice(0, 11);
          this.podImage = response.body.image_link;
          this.snackBar.open("POD Uploaded Successfully", "Success", {
            duration: 5000,
          });
        } else {
          this.snackBar.open(
            "Please upload JPG, JPEG, PNG, or PDF file",
            "Fail",
            { duration: 5000 }
          );
        }
      }
    }, (error) => {
      this.podLoading = false;
      if (error.error.message === "jwt malformed" || error.error.message === "jwt expired" || error.error.message === "invalid signature") {
        this.router.navigateByUrl("admin/login");
        window.localStorage.clear();
      }
      this.snackBar.open("POD Upload Failed: " + (error.error.message || "Unknown error"), "Fail", { duration: 5000 });
    });
  }

  removeImg(event: any, type: any) {
    if (type == "POD") {
      this.uploadPod = true;
      this.podImage = "";
    }
  }
}
